"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFullStoryInstalled = void 0;
var lodash_1 = require("lodash");
var utils_1 = require("../../utils");
var _1 = require(".");
// See fullstory.html for details about when FS gets installed for a user.
exports.isFullStoryInstalled = function () {
    return utils_1.isBrowser() && !!window.FS && lodash_1.isFunction(_1.getFullStory().identify);
};
